import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { TransmissionTypeRes } from '../patients/index.type';

interface ITransmission {
  key: string;
  value: string;
}

const useFetchTransmission = () => {
  const [transmissionType, setTransmissionType] = React.useState<ITransmission[]>([]);

  const { loading: fetchingTransmissionType, makeApiCall } = useApi({
    url: `/rtm/transmission/type`,
    method: 'GET',
  });

  const getTransmissionType = async () => {
    const { response, error } = await makeApiCall<undefined, TransmissionTypeRes>();

    if (response?.status && response.data) {
      setTransmissionType(response.data); // Make sure response.data is an array
    } else {
      setTransmissionType([]);
      toast.error('Something went wrong while fetching transmission types. Please try again later');
    }
  };

  return {
    transmissionType,
    getTransmissionType,
    fetchingTransmissionType,
  };
};

export default useFetchTransmission;



